import { SettingsPanel } from '../components/SettingsPanel';

export function SettingsTool() {
  return <SettingsPanel />;
}
